var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 32,
    viewBox: "0 0 23 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 28C9.8125 28 8.5 26.6875 8.5 25H14.4531C14.4531 26.6875 13.1406 28 11.5 28ZM21.5781 21.0156C21.8594 21.2969 22 21.6719 22 22C21.9531 22.7969 21.3906 23.5 20.4531 23.5H2.5C1.5625 23.5 1 22.7969 1 22C0.953125 21.6719 1.09375 21.2969 1.375 21.0156C2.26562 20.0312 4 18.5781 4 13.75C4 10.1406 6.53125 7.23438 10 6.48438V5.5C10 4.70312 10.6562 4 11.5 4C12.2969 4 12.9531 4.70312 12.9531 5.5V6.48438C16.4219 7.23438 18.9531 10.1406 18.9531 13.75C18.9531 18.5781 20.6875 20.0312 21.5781 21.0156Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.910736e6eda883ad28967e422fa49aba.svg";
export { ForwardRef as ReactComponent };